import { CrossIcon, TrashIcon } from "../../assets/icons";
import { LayersCard } from "../LayersCard/LayersCard";
import "./EditLayers.scss";
export const EditLayers = ({
  onDelete = () => {},
  onCancel = () => {},
  crossClickHandler = () => {},
  layersMenu = [],
  onEditLayer = () => {},
}) => {

  return (
    <LayersCard
      title="Edit Layers"
      layersMenu={layersMenu}
      crossClickHandler={crossClickHandler}
      handleCallBackCheckLayer={() => {}}
      isCheckbox={false}
      hasEyes={false}
      hasEdit={true}
      onEditLayer={onEditLayer}
      className="delete-layer-card-wrapper"

    >
      <div className="delete-layers-button-wrapper">
        <button className="action-button cancel-button" onClick={onCancel}>
          <CrossIcon />
          <span>Annulla</span>
        </button>
        <button className="action-button delete-button" onClick={onDelete}>
          <TrashIcon fillColor="white" />
          <span>Elimina</span>
        </button>
      </div>
    </LayersCard>
  );
};
